import React, {useEffect, useRef} from "react";
import {shapes} from "@joint/core";
import {customShapesMap} from "./Elements";
import {calculateLayout, drawGraph} from "./Layout";
import {defaults} from "./Defaults";

shapes.custom = {};
customShapesMap.forEach((value, key) => {
    shapes.custom[key] = value;
});

export const OrgSchema = (props) => {
    const {archiveObjects} = props;
    const ref = useRef(null);
    let layout = null;

    useEffect(() => {
        layout = calculateLayout(archiveObjects);

        const currentRef = ref.current;
        const width = currentRef.clientWidth;
        const height = currentRef.clientHeight;
        drawGraph(width, height, layout);
    }, []);

    return (<React.Fragment>
        <h2>Org Schema</h2>
        <div id={"joint_wrapper"}
             style={{borderColor: defaults.paperBorderColor, borderWidth: 1, borderStyle: "solid", overflow: "auto"}}>
            <div ref={ref} id={"joint_paper"}/>
        </div>
    </React.Fragment>);

}
